import { loadScript, PayPalScriptOptions } from "@paypal/paypal-js";
import { ShoppingBasket_ProceedToCheckout } from './gak-ShoppingBasket';

declare const ShoppingBasketParms: any;
const requestHeaders: HeadersInit = new Headers();
requestHeaders.set('Content-Type', 'application/json');

const DisabledFundings = "card,bancontact,blik,eps,giropay,ideal,mercadopago,mybank,p24,sepa,sofort,venmo";

export function loadPayPalButton(
    scriptOptions: PayPalScriptOptions,
    label?:
        | "paypal"
        | "checkout"
        | "buynow"
        | "pay"
        | "installment"
        | "subscribe"
        | "donate",
    isSlideOutBasket = false) {
    var paypalButtonContainer = document.getElementById("paypal-button-container");
    if (paypalButtonContainer) {
        scriptOptions.disableFunding = DisabledFundings;
        loadScript(scriptOptions)
            .then((paypal) => {
                paypal!.Buttons!({
                    style: {
                        shape: "pill",
                        height: 41,
                        label: label,
                        disableMaxWidth: true
                    },
                    createOrder: function () {
                        if (isSlideOutBasket) {
                            return fetch(ShoppingBasketParms.CheckoutWithPayPalURL, {
                                method: 'POST',
                            }).then(function (res) {
                                if (res.ok)
                                    return PayPalSetExpressCheckout();
                            });
                        }
                        else {
                            const updateForm = <HTMLFormElement>document.getElementById("UpdateStockForm");
                            const dojj = (<HTMLInputElement>document.getElementById("dojj"))!;
                            const url = updateForm.getAttribute('action')!;
                            const data = new FormData(updateForm);

                            data.set("btoajDelvOptParams", dojj.value);
                            data.set("checkout", "pp");
                            data.set("IsDigitalWallet", "false");

                            return fetch(url, {
                                method: 'POST',
                                body: data,
                            }).then(function () {
                                return PayPalSetExpressCheckout();
                            })
                        }
                    },
                    onApprove(data) {
                        const ppButton = document.createElement("button");

                        ppButton.setAttribute("data-payment-mehtod", "PAYPAL")
                        ppButton.addEventListener("click", ShoppingBasket_ProceedToCheckout);
                        ppButton.click();

                        return fetch(ShoppingBasketParms.PayPalSettle, {
                            method: "POST",
                            headers: requestHeaders,
                            body: JSON.stringify({
                                token: data.orderID,
                                payerId: data.payerID
                            })
                        }).then((response) => response.json())
                            .then((orderData) => {
                                if (orderData.success === true) {
                                    let spinner = document.querySelector(".page-loading-spinner.darker");
                                    if (spinner) {
                                        spinner.classList.remove("hidden");
                                    }

                                    let modalBasket = document.getElementById("modalbasket");

                                    if (modalBasket) {
                                        modalBasket.setAttribute("hidden", "hidden");
                                    }
                                    window.location.href = ShoppingBasketParms.PayPalConfirm;
                                } else {
                                    window.location.href = ShoppingBasketParms.PayPalErrorURL;
                                }
                            });
                    },
                    onError(err) {
                        window.location.href = ShoppingBasketParms.PayPalErrorURL;
                    }
                }).render('#paypal-button-container');
            })
            .catch((err) => {
                console.error("failed to load the PayPal JS SDK script", err);
            });
    }

    function PayPalSetExpressCheckout() {
        return fetch(ShoppingBasketParms.PayPalSetExpressCheckout, {
            method: 'post',
            headers: requestHeaders
        }).then(function (res) {
            return res.json();
        }).then(function (data) {
            return data.token;
        });
    }
}